import {Component, Input, Output, EventEmitter, ViewChild, SimpleChange} from "@angular/core";
import {Funcoes} from "../../funcoes";

declare let $:any;
declare let PNotify: any;

@Component({
  selector: 'widget-avatar',
  template: `<div [formGroup]="form">
                <label class="control-label text-right {{labelClass}}" for="filesToUpload{{id}}" [class.active]="model">{{ txtLabel | translate }}</label>
                <div class="{{containerInputClass}}">
                  
                  <img id="avatar{{id}}" src="{{model}}" class="img-circle" style="border: 2px solid #262b36; padding: 4px; cursor: pointer; width:92px;height: 92px;"
                   (click)="fileInput.click()" />
                   <br><br>
                   <button type="button" (click)="rmAvatar()" class="btn btn-xs btn-danger" *ngIf="showRemoveBtn">{{'front.removerAvatar' | translate}}</button>

                  <input name="filesToUpload{{id}}" id="filesToUpload{{id}}" accept="image/*" type="file" style="display: none;"
                    #fileInput
                    (change)="changeImg()"
                    [disabled]="readonly"/>
                  
                  <div *ngIf="!form.controls[id].valid">
                    <span class="help-block" *ngFor="let erro of form.controls[id].errors[id] | keysBack">{{ 'back.'+erro.key | translate:erro.replace }}</span>
                  </div>
                </div>
                
                <!-- Modal selecionar avatar  -->
                <div class="modal bounceIn animated" id="alterarAvatar{{id}}" tabindex="-1" role="dialog" data-keyboard="false" data-backdrop="static" aria-labelledby="alterarAssinatura" aria-hidden="true">
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h4 class="modal-title" id="myModalLabel">{{'front.alterarAvatar' | translate}}</h4>
                            </div>
                            <div class="modal-body">
                                <form id="formAlterarAvatar{{id}}" action="#" onsubmit="return false;" class="form-horizontal">
                                    <div class="form-group form-group-xs">
                                        <div class="col-sm-12" id="preavatar{{id}}">
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-xs btn-default" data-dismiss="modal" (click)="cancelaAvatar()">{{'front.fechar' | translate}}</button>
                                <button type="button" class="btn btn-xs btn-primary" (click)="confirmaAvatar()">{{'front.confirmar' | translate}}</button>
                            </div>
                        </div><!-- modal-content -->
                    </div><!-- modal-dialog -->
                </div><!-- modal -->

              </div>`,
})

export class WidgetAvatarComponent {
  @Input()
  id: string = '';

  @Input()
  model: any = '';

  @Output() modelChange = new EventEmitter<string>();

  @Input()
  form: any;

  @Input()
  txt_default_erro: any;

  @Input()
  txtLabel: string = '';

  @Input()
  labelClass: string = 'col-sm-2';

  @Input()
  containerInputClass: string = 'col-sm-10';

  @Input()
  urlSemAvatar: string = '/assets/assets/images/faces/face4.png';

  @ViewChild('fileInput')
  fileInput: any;

  @Input()
  readonly: boolean = false;

  uploadCrop: any;
  showRemoveBtn: boolean = false;

  constructor(private func: Funcoes){}

  ngOnChanges(changes: {[ propName: string]: SimpleChange}) {
    for (let change in changes) {
      if(change == 'model'){
        if(changes[change].currentValue != '/assets/assets/images/faces/face4.png'){
          this.showRemoveBtn = true;
        }
      }
    }
  }

  update(val : string) {
    this.model = val;
    console.log(this.model);
    this.modelChange.emit(this.model);
  }

  resizeAndUpload(myFile){

    this.uploadCrop = $('#preavatar'+this.id).croppie({
      viewport: {
        width: 100,
        height: 100,
        type: 'square'
      },
      boundary: {
        width: 300,
        height: 300
      },
      exif: true
    });

    let reader = new FileReader();

    let self = this;

    reader.onload = function (e) {
      self.uploadCrop.croppie('bind', {
        url: e.target['result']
      });
    }

    reader.readAsDataURL(myFile);

    $('#alterarAvatar'+this.id).modal('show');
  }

  changeImg(){

    let files = document.getElementById('filesToUpload' + this.id)['files'];

    for (let i = 0; i < files.length; i++) {

      let ext = files[i].name.split('.').pop().toLowerCase();

      if (ext != 'png' && ext != 'gif' && ext != 'jpg' && ext != 'jpeg' && ext != 'ico') {

        new PNotify({
          title: this.func.traduzir('back.erro'),
          text: this.func.traduzir('front.extensaoInvalida'),
          addclass: 'bg-danger',
          icon: 'icon-warning22'
        });

      } else {
        this.resizeAndUpload(files[i]);
      }

    }
  }

  cancelaAvatar() {
    $('#preavatar'+this.id).html('');
    this.fileInput.nativeElement.value = null;
  }

  confirmaAvatar(){

    let self = this;
    this.uploadCrop.croppie('result', {
      type: 'canvas',
      size: 'viewport'
    }).then(function (resp) {

      self.showRemoveBtn = true;

      self.update(resp);

      $('#alterarAvatar'+self.id).modal('hide');
      $('#preavatar'+self.id).html('');
      self.fileInput.nativeElement.value = null;
    });

  }

  // apaga o avatar
  rmAvatar() {
    this.update(this.urlSemAvatar);
    this.showRemoveBtn = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/form/widget-avatar.component.ts